import { BigNumber } from "bignumber.js";

export const setupDecimal = () => {
  BigNumber.set({
    EXPONENTIAL_AT: [-100, 100],
    ROUNDING_MODE: BigNumber.ROUND_FLOOR,
  });
};

type Result<
  T extends BigNumber.Value | undefined,
  U extends BigNumber.Value | undefined,
> = T extends undefined
  ? undefined
  : U extends undefined
    ? undefined
    : U extends undefined
      ? undefined
      : BigNumber;
export const mul = <
  T extends BigNumber.Value | undefined,
  U extends BigNumber.Value | undefined,
>(
  a: T,
  b: U,
): Result<T, U> => {
  if (typeof a === "undefined" || typeof b === "undefined")
    return undefined as Result<T, U>;

  return new BigNumber(a).multipliedBy(b) as Result<T, U>;
};

export const div = <
  T extends BigNumber.Value | undefined,
  U extends BigNumber.Value | undefined,
>(
  numenator: T,
  denumenator: U,
) => {
  if (typeof numenator === "undefined" || typeof denumenator === "undefined")
    return undefined as Result<T, U>;
  return new BigNumber(numenator).div(denumenator) as Result<T, U>;
};

export const pow = (a: BigNumber.Value, b: BigNumber.Value) => {
  return new BigNumber(a).pow(b);
};

export const minus = (a: BigNumber.Value, b: BigNumber.Value) => {
  return new BigNumber(a).minus(b);
};
export const plus = (a: BigNumber.Value, b: BigNumber.Value) =>
  new BigNumber(a).plus(b);

export const zero = () => {
  return new BigNumber(0);
};

export const toBn = (value: BigNumber.Value) => {
  return new BigNumber(value);
};
